/* Denovo — compra direto no card de produto (14/09/2026)
   Markup: snippets/product-grid-colors.liquid e snippets/product-grid-sizes.liquid.
   - hover na cor (desktop): troca a foto do card
   - clique na cor: troca foto, nome, preço, link e tamanhos
   - tamanho disponível: /cart/add.js e vai para /cart (a loja usa carrinho em página)
   - tamanho esgotado: modal "avise-me", mesmo envio de snippets/product-form.liquid
   Eventos delegados no document: funciona também em cards carregados por AJAX
   (recomendações, busca). IDs/classes próprios para não colidir com o #notifyModal
   da página de produto. */
(function () {
  'use strict';

  var WIDTHS = [360, 540, 720, 900, 1080];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Mesmas regras de snippets/product-grid-price.liquid: Pix -5%, até 4x sem juros no preço cheio
  var PIX_DISCOUNT_PERCENT = 5;
  var MAX_INSTALLMENTS = 4;

  function priceHTML(color) {
    var pix = Math.round(color.price * (100 - PIX_DISCOUNT_PERCENT) / 100);
    var installment = Math.round(color.price / MAX_INSTALLMENTS);
    var html = '<div class="grid-product__pix">';
    if (color.compareAt > color.price) {
      html += '<span class="visually-hidden">Preço normal</span>' +
        '<s class="grid-product__price--original">' + money(color.compareAt) + '</s>';
    }
    if (color.priceVaries) html += '<span class="grid-product__pix-from">A partir de </span>';
    html += '<span class="grid-product__pix-value">' + money(pix) + '</span> ' +
      '<span class="grid-product__pix-label">no Pix</span></div>' +
      '<div class="grid-product__installments">Ou ' + MAX_INSTALLMENTS + 'x de ' + money(installment) + ' s/juros</div>';
    return html;
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function colorsOf(card) {
    if (!card._denovoColors) {
      var el = card.querySelector('[data-card-colors]');
      try { card._denovoColors = el ? JSON.parse(el.textContent) : {}; }
      catch (e) { card._denovoColors = {}; }
    }
    return card._denovoColors;
  }

  /* ---------- imagem ---------- */

  function setImage(img, pattern) {
    if (!img || !pattern) return;
    img.setAttribute('data-src', pattern); // lazysizes recalcula a partir daqui
    img.setAttribute('srcset', WIDTHS.map(function (w) {
      return pattern.replace('{width}', w) + ' ' + w + 'w';
    }).join(', '));
    img.setAttribute('src', pattern.replace('{width}', 540));
  }

  function showColorImage(card, handle) {
    var color = colorsOf(card)[handle];
    if (!color) return;
    setImage(card.querySelector('.grid-product__image-mask .grid__image-ratio img, .grid-product__image-mask img.grid-product__image'), color.image);

    var secondary = card.querySelector('.grid-product__secondary-image');
    if (secondary) {
      secondary.style.visibility = color.image2 ? '' : 'hidden';
      if (color.image2) setImage(secondary.querySelector('img'), color.image2);
    }
  }

  /* ---------- troca de cor ---------- */

  function sizeHTML(size, multiOption) {
    var cls = 'grid-product__size' + (size.available ? '' : ' grid-product__size--unavailable');
    if (multiOption) {
      return '<span class="' + cls + '">' + esc(size.value) + '</span>';
    }
    var label = size.available
      ? 'Adicionar tamanho ' + size.value + ' ao carrinho'
      : 'Tamanho ' + size.value + ' esgotado, avise-me quando chegar';
    return '<button type="button" class="' + cls + '" data-variant-id="' + esc(size.id) +
      '" data-size="' + esc(size.value) + '" data-available="' + size.available +
      '" aria-label="' + esc(label) + '">' + esc(size.value) + '</button>';
  }

  function selectColor(card, handle) {
    var color = colorsOf(card)[handle];
    if (!color) return;

    card._denovoSelected = handle;
    showColorImage(card, handle);

    var link = card.querySelector('.grid-product__link');
    if (link && color.url) link.setAttribute('href', color.url);

    var title = card.querySelector('.grid-product__title');
    if (title) title.textContent = color.title;

    var price = card.querySelector('.grid-product__price');
    if (price) price.innerHTML = priceHTML(color);

    var sizes = card.querySelector('[data-card-sizes]');
    if (sizes) {
      sizes.innerHTML = color.sizes.map(function (s) { return sizeHTML(s, color.multiOption); }).join('');
    }

    var msg = card.querySelector('.grid-product__shop-msg');
    if (msg) msg.remove();

    card.querySelectorAll('.grid-product__swatch').forEach(function (sw) {
      var active = sw.getAttribute('data-color-handle') === handle;
      sw.classList.toggle('is-active', active);
      sw.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ---------- carrinho ---------- */

  function showMessage(card, text) {
    var anchor = card.querySelector('[data-card-sizes]') || card.querySelector('.grid-product__swatches');
    if (!anchor) return;
    var msg = card.querySelector('.grid-product__shop-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'grid-product__shop-msg';
      msg.setAttribute('role', 'alert');
      anchor.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = text;
  }

  function addToCart(button, card) {
    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw json;
          return json;
        });
      })
      .then(function () {
        window.location.href = ROOT + 'cart';
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        showMessage(card, (err && (err.description || err.message)) || 'Não foi possível adicionar. Tente novamente.');
      });
  }

  /* ---------- avise-me ---------- */

  var modal = null;
  var request = null;
  var lastFocus = null;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'denovo-notify';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="denovo-notify__overlay" data-notify-close></div>' +
      '<div class="denovo-notify__box" role="dialog" aria-modal="true" aria-labelledby="DenovoNotifyTitle">' +
        '<button type="button" class="denovo-notify__close" data-notify-close aria-label="Fechar">&times;</button>' +
        '<h3 id="DenovoNotifyTitle" class="denovo-notify__title">Avise-me quando chegar</h3>' +
        '<p class="denovo-notify__product"></p>' +
        '<form class="denovo-notify__form" novalidate>' +
          '<input type="email" name="email" placeholder="Seu e-mail" required autocomplete="email" aria-label="Seu e-mail">' +
          '<button type="submit" class="btn btn--full">Cadastrar</button>' +
        '</form>' +
        '<p class="denovo-notify__status" role="status" aria-live="polite"></p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-notify-close]')) closeNotify();
    });
    modal.querySelector('form').addEventListener('submit', submitNotify);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeNotify();
    });
  }

  function openNotify(card, button) {
    if (!modal) buildModal();
    var title = card.querySelector('.grid-product__title');
    request = {
      title: title ? title.textContent.trim() : '',
      size: button.getAttribute('data-size'),
      variant: button.getAttribute('data-variant-id')
    };

    modal.querySelector('.denovo-notify__product').innerHTML =
      '<strong>' + esc(request.title) + '</strong><br>Tamanho ' + esc(request.size);
    var form = modal.querySelector('form');
    form.reset();
    form.hidden = false;
    modal.querySelector('.denovo-notify__status').textContent = '';

    lastFocus = button;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    form.querySelector('input[type="email"]').focus();
  }

  function closeNotify() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  function submitNotify(e) {
    e.preventDefault();
    var form = e.target;
    var status = modal.querySelector('.denovo-notify__status');
    var email = form.email.value.trim();

    if (!form.email.checkValidity() || !email) {
      status.textContent = 'Informe um e-mail válido.';
      form.email.focus();
      return;
    }

    form.hidden = true;
    status.textContent = 'Enviando seu cadastro...';

    // Mesmo payload de submitNotify() em snippets/product-form.liquid, com o tamanho no corpo
    fetch(ROOT + 'contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form_type': 'customer',
        'utf8': '✓',
        'contact[email]': email,
        'contact[subject]': 'Aviso de Estoque - ' + request.title,
        'contact[body]': 'Produto: ' + request.title + '\nTamanho: ' + request.size +
          '\nVariante ID: ' + request.variant + '\nEmail: ' + email +
          '\n\nO cliente solicitou ser notificado quando este produto voltar ao estoque.'
      })
    })
      .then(function (res) {
        if (!res.ok) throw res;
        status.textContent = 'Seu e-mail foi cadastrado! Você será avisado assim que este tamanho voltar ao estoque.';
        setTimeout(closeNotify, 2500);
      })
      .catch(function () {
        status.textContent = 'Erro ao cadastrar. Tente novamente.';
        form.hidden = false;
      });
  }

  /* ---------- eventos ---------- */

  document.addEventListener('mouseover', function (e) {
    if (!canHover || !e.target.closest) return;
    var swatch = e.target.closest('.grid-product__swatch');
    if (!swatch) return;
    var card = swatch.closest('.grid-product');
    if (card) showColorImage(card, swatch.getAttribute('data-color-handle'));
  });

  document.addEventListener('mouseout', function (e) {
    if (!canHover || !e.target.closest) return;
    var list = e.target.closest('.grid-product__swatches');
    if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
    var card = list.closest('.grid-product');
    if (card) showColorImage(card, card._denovoSelected || card.getAttribute('data-product-handle'));
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    // "+N": mostra todas as cores do card
    var more = e.target.closest('.grid-product__swatch-more');
    if (more) {
      e.preventDefault();
      var list = more.closest('.grid-product__swatches');
      if (list) list.classList.add('is-expanded');
      more.setAttribute('aria-expanded', 'true');
      var firstHidden = list && list.querySelectorAll('.grid-product__swatch')[4];
      if (firstHidden) firstHidden.focus();
      return;
    }

    var swatch = e.target.closest('.grid-product__swatch');
    if (swatch) {
      e.preventDefault();
      var swatchCard = swatch.closest('.grid-product');
      if (swatchCard) selectColor(swatchCard, swatch.getAttribute('data-color-handle'));
      return;
    }

    var size = e.target.closest('button.grid-product__size');
    if (size) {
      e.preventDefault();
      var sizeCard = size.closest('.grid-product');
      if (!sizeCard) return;
      if (size.getAttribute('data-available') === 'true') addToCart(size, sizeCard);
      else openNotify(sizeCard, size);
    }
  });

  /* ---------- página de produto: botões −/+ (snippets/product-form.liquid, .denovo-qty) ---------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('.denovo-qty [data-quantity-selector]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.closest('.denovo-qty').querySelector('[data-quantity-value]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 9999;
    var value = parseInt(input.value, 10) || min;
    value += btn.hasAttribute('data-increase-qty') ? 1 : -1;
    input.value = Math.min(max, Math.max(min, value));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Digitação livre: corrige vazio, zero ou acima do máximo ao sair do campo
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.denovo-qty [data-quantity-value]')) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 9999;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < min) value = min;
    if (value > max) value = max;
    if (String(value) !== input.value) input.value = value;
  });
})();
